// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1Fr9g","approved":"Status_approved__x3fTp","rejected":"Status_rejected__1ShJp","expired":"Status_expired__2npW0","label":"Status_label__1ZEBi"};